<div [formGroup]="form" class="form-group">
  <label>{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <app-info-icon
    [message]="field.infoIconMessage"
    *ngIf="field.infoIconMessage"
  ></app-info-icon>
  <div
    class="file-input-container"
    [ngClass]="{ 'file-input-placeholder': !form.get(field.name)?.value }"
    (click)="triggerFileInput()"
  >
    <input
      type="file"
      #fileInput
      style="display: none"
      (change)="onFileSelected($event)"
      onclick="this.value = null"
      appMobileBridgeFileInput
    />
    <div class="attach-logo">
      <em class="icon-liteattach"></em>
    </div>
    <div *ngIf="form.get(field.name)?.value">
      <em class="icon-litedocument"></em>
      <span class="c-ml-10px">{{ fileFieldName }}</span>
    </div>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
